var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLandingSlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 29,
    viewBox: "0 0 18 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.866,
    y: 0.643555,
    width: 1,
    height: 32,
    transform: "rotate(30 16.866 0.643555)",
    fill: "url(#paint0_linear_37_192)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_37_192",
    x1: 17.366,
    y1: 0.643555,
    x2: 17.366,
    y2: 32.6436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BA6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34C6F1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingSlash);
export default __webpack_public_path__ + "static/media/landingSlash.564fbeba265ef68e67932b38f64d987d.svg";
export { ForwardRef as ReactComponent };